'use strict';
import logger from '@main/externals/bss-package-logger/js/logger';
import helper from '@main/externals/bss-package-helper/js/helper';
import { DateTime } from 'luxon';
import numbro from '../../numbro/js/numbro';
import { toolbox } from '../../bss-package-toolbox/js/toolbox.js';
var _formatters = null;
/**
 * Formatter class
 */
var Formatter = /** @class */ (function () {
    /**
     * @desc Formatter constructor
     * @param {Object} [formatters=null] - formatters configuration
     */
    function Formatter(formatters) {
        if (formatters === void 0) { formatters = null; }
        helper.validateMethodParams(arguments, {
            formatters: {
                isa: 'object',
            },
        });
        if (formatters === null) {
            throw 'ERROR: parameter: formatters is necessary;';
        }
        else if (Object.prototype.toString.call(formatters) !== '[object Object]') {
            throw 'ERROR: parameter: formatters must be Object;';
        }
        logger.info('Package: Formatter => constructor | Params: ', formatters, logger);
        this._initializeFormatters(formatters);
    }
    /**
     * @desc _initializeFormatters - initialize _formatters object with methods and setting
     * @param {Object} formatters - formatter settings
     * @private
     */
    Formatter.prototype._initializeFormatters = function (formatters) {
        logger.info('Package: Formatter => function :  _initializeFormatters | Params: ', formatters);
        _formatters = {};
        for (var item in formatters) {
            _formatters[item] = numbro.convertWnumbToNumbroFormat(formatters[item]);
            _formatters[item + 'Settings'] = formatters[item];
            numbro.registerFormatter(_formatters[item], formatters[item], item);
        }
    };
    /**
     * @desc formats the date, uses momentu library
     * @param {number} value - value to format
     * @param {Object} formatSettings - formatter setting object
     * @return {Object} format date
     * @private
     */
    Formatter.prototype._dateFormat = function (value, formatSettings) {
        logger.info('Package: Formatter => function :  _dateFormat | Params: ', value, formatSettings);
        // Parse the date using the initial format
        var parsedDate = DateTime.fromFormat(value, formatSettings.initialFormat);
        // Return the formatted date using the result format
        return parsedDate.toFormat(formatSettings.resultFormat);
    };
    /**
     * @desc formats the duration in polish language
     * @param {Number} value - value to format
     * @param {Object} formatSettings - formatter setting object
     * @param {String} formatName - formatter name
     * @return {Object} format plDuration
     * @private
     */
    Formatter.prototype._plDurationFormat = function (value, formatSettings, formatName) {
        logger.info('Package: Formatter => function :  _plDurationFormat | Params: ', value, formatSettings, formatName);
        var intValue = parseInt(value);
        var stringValue = value.toString();
        var stringLength = stringValue.length;
        var modulo = Math.pow(10, stringLength);
        var moduloFromValue = intValue % modulo;
        if ((moduloFromValue >= 22 &&
            (moduloFromValue % 10 === 2 ||
                moduloFromValue % 10 === 3 ||
                moduloFromValue % 10 === 4)) ||
            (moduloFromValue >= 2 && moduloFromValue <= 4)) {
            formatSettings.postfix = ' miesiące';
        }
        else if (parseInt(value) === 1) {
            formatSettings.postfix = ' miesiąc';
        }
        else {
            formatSettings.postfix = ' miesięcy';
        }
        return numbro.formatUniversal(parseFloat(value), formatSettings, formatName);
    };
    /**
     * @desc formats the duration in croatia language
     * @param {Number} value - value to format
     * @param {Object} formatSettings - formatter setting object
     * @param {String} formatName - formatter name
     * @return {Object} format hrDuration
     * @private
     */
    Formatter.prototype._hrDurationFormat = function (value, formatSettings, formatName) {
        logger.info('DEBUG: Package: Formatter => function :  _hrDurationFormat | Params: ', value, formatSettings, formatName);
        var intValue = parseInt(value);
        var stringValue = value.toString();
        var stringLength = stringValue.length;
        var modulo = Math.pow(10, stringLength);
        var moduloFromValue = intValue % modulo;
        if ((moduloFromValue >= 22 &&
            (moduloFromValue % 10 === 2 ||
                moduloFromValue % 10 === 3 ||
                moduloFromValue % 10 === 4)) ||
            (moduloFromValue >= 2 && moduloFromValue <= 4)) {
            formatSettings.postfix = ' mjeseca';
        }
        else if (parseInt(value) === 1) {
            formatSettings.postfix = ' mjesec';
        }
        else {
            formatSettings.postfix = ' mjeseci';
        }
        return numbro.formatUniversal(parseFloat(value), formatSettings, formatName);
    };
    /**
     * @desc formats the duration in croatia language
     * @param {Number} value - value to format
     * @param {Object} formatSettings - formatter setting object
     * @param {String} formatName - formatter name
     * @return {Object} format siDuration
     * @private
     */
    Formatter.prototype._siDurationFormat = function (value, formatSettings, formatName) {
        logger.info('DEBUG: Package: Formatter => function :  _hrDurationFormat | Params: ', value, formatSettings, formatName);
        var intValue = parseInt(value);
        if (intValue === 1) {
            formatSettings.postfix = ' mesec';
        }
        else if (intValue === 2) {
            formatSettings.postfix = ' meseca';
        }
        else if (intValue === 3 || intValue === 4) {
            formatSettings.postfix = ' mesece';
        }
        else if (intValue > 4) {
            formatSettings.postfix = ' mesecev';
        }
        return numbro.formatUniversal(parseFloat(value), formatSettings, formatName);
    };
    /**
     *
     * @param {Number} value - value to format
     * @param {Object} formatSettings - formatter setting object
     * @param {String} formatName - formatter name
     * @return {Object} format ruDuration
     * @private
     * @example
     * if number ends with "1" - месяц;
     * if number ends with 2-4 - месяца;
     * if 11-19 - месяцев
     * else - месяцев
     */
    Formatter.prototype._ruDurationFormat = function (value, formatSettings, formatName) {
        logger.info('Package: Formatter => function :  _ruDurationFormat | Params: ', value, formatSettings, formatName);
        var intValue = parseInt(value);
        var stringValue = value.toString();
        var stringLength = stringValue.length;
        var modulo = Math.pow(10, stringLength);
        var moduloFromValue = intValue % modulo;
        if (moduloFromValue % 10 === 1 && intValue !== 11) {
            formatSettings.postfix = ' месяц';
        }
        else if ((intValue < 11 || intValue > 19) &&
            (moduloFromValue % 10 === 2 ||
                moduloFromValue % 10 === 3 ||
                moduloFromValue % 10 === 4)) {
            formatSettings.postfix = ' месяца';
        }
        else {
            formatSettings.postfix = ' месяцев';
        }
        return numbro.formatUniversal(parseFloat(value), formatSettings, formatName);
    };
    /**
     * @desc formats value with use of formatCurrency
     * @param {Number} value - value to format
     * @param {Object} formatName - formatter setting object
     * @param {Object} [formatSettings = {}] - formatter setting object
     * @private
     * @return {String} formatSettings date
     */
    Formatter.prototype._standardFormat = function (value, formatName, formatSettings) {
        if (formatSettings === void 0) { formatSettings = {}; }
        logger.info('Package: Formatter => function : _standardFormat | Params: ', value, formatName);
        this._setMonthsSuffix(value, formatName, formatSettings);
        if (formatName !== 'frCurrencyNoDecimalsThousandSpace' &&
            formatName !== 'ruSpecialCurrencyNoDecimalsThousandSpace' &&
            formatName !== 'plCurrencyNoDecimalsThousandSpace') {
            return numbro.formatUniversal(parseFloat(value), formatSettings, formatName);
        }
        else if (formatName === 'seCurrencyNoDecimals') {
            return numbro.formatUniversal(parseFloat(Math.round(value)), formatSettings, formatName);
        }
        return numbro.formatUniversal(parseFloat(Math.round(value)), formatSettings, formatName);
    };
    /**
     * @desc set proper month suffix,
     * eg 'month' for value equal 1 and 'months' for bigger value using ' month, months' suffix list
     * @param {Number} value - value to format
     * @param {Object} formatName - formatter setting object
     * @param {Object} formatSettings - formatter setting object
     * @private
     * @return {String} formatSettings date
     */
    Formatter.prototype._setMonthsSuffix = function (value, formatName, formatSettings) {
        logger.info('Package: Formatter => function : _setMonthsSuffix | Params: ', value, formatSettings);
        var singleSuffix = ['nlCurrencyNoDecimals'];
        // If there is more than 1 month suffix
        var suffixList = formatSettings.postfix
            ? formatSettings.postfix.split(',')
            : [];
        if (singleSuffix.includes(formatName)) {
            suffixList = [formatSettings.postfix];
        }
        if (suffixList.length > 1) {
            var intValue = parseInt(value);
            var stringValue = value.toString();
            var stringLength = stringValue.length;
            var modulo = Math.pow(10, stringLength);
            var moduloFromValue = intValue % modulo;
            var suffix = void 0;
            if (intValue === 1) {
                suffix = suffixList[0];
            }
            else if ((intValue < 11 || intValue > 19) &&
                (moduloFromValue % 10 === 2 ||
                    moduloFromValue % 10 === 3 ||
                    moduloFromValue % 10 === 4)) {
                suffix = suffixList[1];
            }
            else {
                suffix = suffixList.length > 2 ? suffixList[2] : suffixList[1];
            }
            var customSettings = toolbox._.merge({}, formatSettings, { suffix: suffix });
            _formatters[formatName] =
                numbro.convertWnumbToNumbroFormat(customSettings);
            _formatters[formatName + 'DefaultSettings'] = formatSettings;
            _formatters[formatName + 'Settings'] = customSettings;
        }
    };
    Object.defineProperty(Formatter.prototype, "formatters", {
        /**
         * @returns _formatters
         * @public
         * @desc _formatters getter
         */
        get: function () {
            return _formatters;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @desc returns format setting object
     * @param {string} formatterName formatter setting name
     * @private
     * @return {Object} format setting object
     */
    Formatter.prototype._getFormatterSettings = function (formatterName) {
        logger.info('Package: Formatter => function :  _getFormatterSettings | Params: ', formatterName);
        if (_formatters[formatterName + 'DefaultSettings']) {
            return _formatters[formatterName + 'DefaultSettings'];
        }
        if (_formatters[formatterName + 'Settings']) {
            return _formatters[formatterName + 'Settings'];
        }
    };
    /**
     * @desc returns formated value
     * @param {String|Number} [value=null] value to format
     * @param {String} [formatterName=null] formatter setting name
     * @return {String} formated value
     */
    Formatter.prototype.getFormattedValue = function (value, formatterName) {
        if (value === void 0) { value = null; }
        if (formatterName === void 0) { formatterName = null; }
        logger.info('Package: Formatter => function :  getFormattedValue | Params: ', value, formatterName);
        if (value === null || formatterName === null) {
            // throw 'ERROR: parameters: value and formatterName are necessary;';
            return value;
        }
        var format = this._getFormatterSettings(formatterName);
        if (typeof format === 'undefined') {
            return value;
        }
        if (formatterName.indexOf('date') === 0) {
            return this._dateFormat(value, format);
        }
        else if (formatterName.indexOf('plDuration') === 0) {
            return this._plDurationFormat(value, format, formatterName);
        }
        else if (formatterName.indexOf('hrDuration') === 0) {
            return this._hrDurationFormat(value, format, formatterName);
        }
        else if (formatterName.indexOf('ruDuration') === 0) {
            return this._ruDurationFormat(value, format, formatterName);
        }
        else if (formatterName.indexOf('siDuration') === 0) {
            return this._siDurationFormat(value, format, formatterName);
        }
        else {
            return this._standardFormat(value, formatterName, format);
        }
    };
    /**
     * @desc returns unformatted value
     * @param {String} [value=null] - formatted string value
     * @param {String} [formatterName=null] formatter setting name
     * @return {String} value from formatted string value
     */
    Formatter.prototype.getValue = function (value, formatterName) {
        if (value === void 0) { value = null; }
        if (formatterName === void 0) { formatterName = null; }
        logger.info('Package: Formatter => function :  getValue | Params: ', value, formatterName);
        if (!formatterName) {
            return value;
        }
        numbro.setLanguage(formatterName);
        return numbro.unformat(value);
    };
    return Formatter;
}());
export default Formatter;
